import { useCallback } from 'react';

import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { fetchTableTopDataAction } from '../../store/apiActions/fetchTableTopDataAction';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';

export const useTableTopDataFetcher = () => {
  const dispatch = useCoreDispatch();
  const tableId = useConfigSlice.tableId() ?? '';
  const gsAddress = useConfigSlice.env()?.gameStats;
  const jwtToken = useConfigSlice.playerConfig()?.jwtToken ?? '';
  const period = useHighflyerGameStateSlice.currentCalenderOption();
  const indexOf = useConfigSlice.env()?.gameStats?.indexOf('.');
  const env = useConfigSlice.env();
  const gsAddressWithBaseURL =
    (env?.playerBaseDomain && gsAddress?.replace(gsAddress.slice(indexOf), `.${env?.playerBaseDomain}`)) || gsAddress;

  return useCallback(
    (category: string, forceFetch: boolean = false) => {
      if (gsAddressWithBaseURL && category && period && tableId) {
        dispatch(
          fetchTableTopDataAction({
            'table-id': tableId,
            category,
            period,
            url: `${gsAddressWithBaseURL}/api/game/stats`,
            JWTTOKEN: jwtToken,
            force: forceFetch,
          })
        );
      }
    },
    [dispatch, period, gsAddressWithBaseURL, tableId]
  );
};
